export default __webpack_public_path__ + "static/media/calendar.8645b1fe.png";